import React from 'react';
import classes from './SuccessModal.module.css';

const SuccessModal = ({ isOpen, onClose, walletDetails, walletGenerated }) => {
    if (!isOpen) return null;

    // Use wallet details if wallet was generated, otherwise use empty
    const {
        walletId = "",
        walletName = "",
        bankName = ""
    } = walletDetails || {};

    return (
        <div className={classes.modalOverlay}>
            <div className={classes.modalContent}>
                <div className={classes.successIconContainer}>
                    <svg className={classes.successIcon} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="25" cy="25" r="23" stroke="currentColor" strokeWidth="4" />
                        <path d="M15 25L22 32L35 18" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>

                <h2 className={classes.title}>Success</h2>
                <p className={classes.subtitle}>Company setup completed successfully</p>

                {walletGenerated ? (
                    <div className={classes.walletSection}>
                        <div className={classes.walletHeader}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
                                <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
                                <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
                            </svg>
                            <span className={classes.walletTitle}>Good news! Your wallet is ready</span>
                        </div>

                        <p className={classes.walletDescription}>
                            We've automatically created a wallet account for you.
                            You can fund it anytime to pay for your subscriptions.
                        </p>

                        <div className={classes.walletDetails}>
                            <div className={classes.detailRow}>
                                <span className={classes.detailLabel}>Wallet ID</span>
                                <span className={classes.detailValue}>{walletId}</span>
                            </div>
                            <div className={classes.detailRow}>
                                <span className={classes.detailLabel}>Wallet Name</span>
                                <span className={classes.detailValue}>{walletName}</span>
                            </div>
                            <div className={classes.detailRow}>
                                <span className={classes.detailLabel}>Bank Name</span>
                                <span className={classes.detailValue}>{bankName}</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={classes.walletSection}>
                        <div className={classes.walletHeader}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                            <span className={classes.walletTitle}>Wallet Setup Pending</span>
                        </div>

                        <p className={classes.walletDescription}>
                            Your company has been set up successfully. To activate your wallet account and enable payment processing, 
                            please verify your BVN (Biometric Verification Number) in your account settings.
                        </p>

                        <div className={classes.warningBox}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3.05h16.94a2 2 0 0 0 1.71-3.05L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                                <line x1="12" y1="9" x2="12" y2="13"></line>
                                <line x1="12" y1="17" x2="12.01" y2="17"></line>
                            </svg>
                            <span>Once your BVN is verified, your wallet will be automatically generated and you'll receive the details via email.</span>
                        </div>
                    </div>
                )}

                <button className={classes.continueButton} onClick={onClose}>
                    Continue
                </button>
            </div>
        </div>
    );
};

export default SuccessModal;
